import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Services from "./Services";
import { SERVICES_DATA } from "../../constant/Services";
import { useParams } from "react-router-dom";
import Eyebrow from "../common/Eyebrow";

const ServicesItems = () => {
  let { pageId } = useParams();
  const serviceData = SERVICES_DATA[pageId.toUpperCase()];

  if (!serviceData) {
    return (
      <>
        <Helmet>
          <title>Service Not Found - QuantaRock</title>
          <meta name="robots" content="noindex,follow" />
        </Helmet>
        <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-24 text-center">
          <Eyebrow className="text-sm">404</Eyebrow>
          <h1 className="mt-4 text-3xl font-bold text-[var(--website-primary-color)] sm:text-4xl">
            Service not found
          </h1>
          <p className="mt-4 max-w-md text-slate-600">
            We couldn't find the service you're looking for.
          </p>
          <Link
            to="/"
            className="mt-8 rounded-lg bg-[var(--website-primary-color)] px-6 py-3 font-semibold text-white transition hover:opacity-90"
          >
            Back to home
          </Link>
        </div>
      </>
    );
  }
  return (
    <Services
      whyChooseUs={serviceData.whyChooseUs}
      serviceSection={serviceData.serviceSection}
      howItWorks={serviceData.howItWorks}
      serviceData={serviceData}
      pageId={pageId}
    />
  );
};

export default ServicesItems;
